import React from 'react'
import {Icon} from '@chakra-ui/react'

const EmailIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.54199 8C1.54199 7.17157 2.21357 6.5 3.04199 6.5H36.9587C37.7871 6.5 38.4587 7.17157 38.4587 8V32C38.4587 32.8284 37.7871 33.5 36.9587 33.5H3.04199C2.21357 33.5 1.54199 32.8284 1.54199 32V8ZM4.54199 9.5V30.5H35.4587V9.5H4.54199Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.2386 21.2922L2.28027 11.2922L3.80411 8.70801L20.0005 18.2587L36.1969 8.70801L37.7208 11.2922L20.7624 21.2922C20.2923 21.5694 19.7087 21.5694 19.2386 21.2922Z"
                fill="black"
            />
        </Icon>
    )
}

export default EmailIcon
